import React from 'react';

const UserLogManagement = () => {
  return (
    <h1>User Log Management</h1>
  )
}
export default UserLogManagement;